import * as React from "react";
import { BaseIcon, BaseIconProps, BaseSVGIconProps } from "./BaseIcon";

const SvgCustomPNGFile = ({
  color,
  alt,
  "aria-roledescription":
    roleDescription = "Represents a Portable Network Graphics (.png) file",
  ...restProps
}: BaseSVGIconProps) => (
  <svg
    width="32"
    height="41"
    viewBox="0 0 32 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <title>{alt}</title>
    {roleDescription ? <desc>{roleDescription}</desc> : null}
    <path
      d="M31.4099 9.26001V37.61C31.4099 38.71 30.5099 39.61 29.4099 39.61H6.62988C5.52988 39.61 4.62988 38.71 4.62988 37.61V2.51001C4.62988 1.41001 5.52988 0.51001 6.62988 0.51001H22.7999L31.4099 9.26001Z"
      fill="white"
    />
    <path
      d="M29.4099 40.1H6.62988C5.24988 40.1 4.12988 38.98 4.12988 37.6V2.5C4.12988 1.12 5.24988 0 6.62988 0H22.7999C22.9299 0 23.0599 0.0500015 23.1599 0.150002L31.7699 8.9C31.8599 8.99 31.9099 9.12 31.9099 9.25V37.6C31.9099 38.98 30.7899 40.1 29.4099 40.1ZM6.62988 1C5.79988 1 5.12988 1.67 5.12988 2.5V37.6C5.12988 38.43 5.79988 39.1 6.62988 39.1H29.4099C30.2399 39.1 30.9099 38.43 30.9099 37.6V9.46L22.5899 1H6.62988Z"
      fill="#C4CBD0"
    />
    <path
      d="M30.8698 9.25998H24.7998C23.6998 9.25998 22.7998 8.35998 22.7998 7.25998V1.16998"
      fill="white"
    />
    <path
      d="M30.8698 9.75998H24.7998C23.4198 9.75998 22.2998 8.63998 22.2998 7.25998V1.16998C22.2998 0.889983 22.5198 0.669983 22.7998 0.669983C23.0798 0.669983 23.2998 0.889983 23.2998 1.16998V7.25998C23.2998 8.08998 23.9698 8.75998 24.7998 8.75998H30.8698C31.1498 8.75998 31.3698 8.97998 31.3698 9.25998C31.3698 9.53998 31.1498 9.75998 30.8698 9.75998Z"
      fill="#C4CBD0"
    />
    <path
      d="M26.03 31.66H1.2C0.540005 31.66 0 31.12 0 30.46V16.52C0 15.86 0.540005 15.32 1.2 15.32H26.03C26.69 15.32 27.23 15.86 27.23 16.52V30.46C27.23 31.12 26.7 31.66 26.03 31.66Z"
      fill="#F18576"
    />
    <path
      d="M3.55043 26.9999V19.7272H6.55469C7.0992 19.7272 7.56913 19.8337 7.96449 20.0468C8.36222 20.2575 8.6688 20.5523 8.88423 20.931C9.09967 21.3075 9.20739 21.7454 9.20739 22.245C9.20739 22.7469 9.0973 23.186 8.87713 23.5624C8.65933 23.9365 8.34801 24.2265 7.94318 24.4325C7.53835 24.6384 7.05777 24.7414 6.50142 24.7414H4.64773V23.3565H6.17472C6.43987 23.3565 6.66122 23.3103 6.83878 23.218C7.0187 23.1256 7.15483 22.9966 7.24716 22.8309C7.33949 22.6628 7.38565 22.4675 7.38565 22.245C7.38565 22.0201 7.33949 21.8259 7.24716 21.6626C7.15483 21.4969 7.0187 21.369 6.83878 21.2791C6.65885 21.1891 6.4375 21.1441 6.17472 21.1441H5.30824V26.9999H3.55043ZM16.2635 19.7272V26.9999H14.772L11.8778 22.8025H11.8317V26.9999H10.0739V19.7272H11.5866L14.4489 23.9176H14.5092V19.7272H16.2635ZM22.1415 22.1029C22.1013 21.9538 22.0421 21.8224 21.964 21.7087C21.8858 21.5927 21.79 21.4945 21.6763 21.414C21.5627 21.3335 21.4325 21.2731 21.2857 21.2329C21.1389 21.1903 20.9779 21.169 20.8027 21.169C20.45 21.169 20.1446 21.2542 19.8865 21.4247C19.6309 21.5951 19.4332 21.8437 19.2935 22.1704C19.1538 22.4947 19.084 22.8889 19.084 23.3529C19.084 23.8193 19.1515 24.217 19.2864 24.5461C19.4213 24.8752 19.6167 25.1261 19.8723 25.2989C20.128 25.4718 20.4382 25.5582 20.8027 25.5582C21.1247 25.5582 21.397 25.5061 21.6195 25.4019C21.8444 25.2954 22.0149 25.1451 22.1309 24.9509C22.2469 24.7568 22.3049 24.5283 22.3049 24.2656L22.6316 24.3046H20.8631V23.0227H23.9988V23.985C23.9988 24.6361 23.8603 25.1936 23.5833 25.6576C23.3087 26.1216 22.9299 26.4779 22.4469 26.7265C21.9663 26.9751 21.4135 27.0994 20.7885 27.0994C20.0949 27.0994 19.4853 26.949 18.9597 26.6484C18.4341 26.3477 18.0246 25.9192 17.731 25.3629C17.4374 24.8042 17.2907 24.1413 17.2907 23.3742C17.2907 22.7776 17.3794 22.2485 17.557 21.7869C17.7346 21.3229 17.9819 20.9299 18.2992 20.6079C18.6188 20.2859 18.9881 20.0421 19.4071 19.8764C19.8285 19.7106 20.2819 19.6278 20.7672 19.6278C21.1886 19.6278 21.5804 19.6881 21.9426 19.8089C22.3072 19.9296 22.6292 20.1001 22.9086 20.3203C23.1903 20.5404 23.4187 20.802 23.5939 21.1051C23.7691 21.4081 23.878 21.7407 23.9206 22.1029H22.1415Z"
      fill="white"
    />
  </svg>
);

const CustomPNGFile = (props: BaseIconProps) => (
  <BaseIcon {...props}>
    <SvgCustomPNGFile />
  </BaseIcon>
);

export default CustomPNGFile;
